import { create } from "zustand";

interface TelegramState {
  tg: TelegramWebApp | null;
  user: TelegramWebAppUser | null;
  isTelegram: boolean;
  colorScheme: "light" | "dark";
  init: () => void;
}

export const useTelegram = create<TelegramState>((set) => ({
  tg: null,
  user: null,
  isTelegram: false,
  colorScheme: "light",

  init: () => {
    const tg = window.Telegram?.WebApp;
    if (!tg?.initData) return;

    tg.ready();
    tg.expand();
    if (tg.isVersionAtLeast("6.1")) {
      tg.setHeaderColor(tg.themeParams.bg_color || "#0A0A0F");
      tg.setBackgroundColor(tg.themeParams.bg_color || "#0A0A0F");
    }
    if (tg.isVersionAtLeast("7.7")) {
      tg.disableVerticalSwipes();
    }
    tg.enableClosingConfirmation();

    set({
      tg,
      user: tg.initDataUnsafe?.user ?? null,
      isTelegram: true,
      colorScheme: tg.colorScheme,
    });

    tg.onEvent("themeChanged", () => {
      set({ colorScheme: tg.colorScheme });
    });
  },
}));

const API_BASE = (import.meta as unknown as { env?: { VITE_API_URL?: string } }).env?.VITE_API_URL ?? "";

export async function telegramAuth(): Promise<{
  access: string;
  refresh: string;
  user: { id: string; username: string; role: string; full_name?: string };
}> {
  const tg = window.Telegram?.WebApp;
  if (!tg?.initData) throw new Error("Not running inside Telegram");

  const res = await fetch(`${API_BASE}/api/v1/auth/telegram/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ init_data: tg.initData }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Telegram auth failed");
  }

  return res.json();
}
